import { useEffect, useState } from "react";
import { useLeadModal } from "@/context/LeadModalContext";

export const StickyMobileCTA = () => {
  const { openModal, open } = useLeadModal();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show || open) return null;

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-ivory/90 backdrop-blur-md border-t hairline">
      <button
        data-testid="sticky-mobile-cta"
        onClick={openModal}
        className="w-full bg-ink text-ivory py-4 text-[11px] tracking-mega font-semibold"
      >
        RICHIEDI ACCESSO
      </button>
    </div>
  );
};
